/* require global playback */

import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import SubscriptionBanner from 'shared/components/subscription_banner';
import ContentGatingBanner from 'shared/components/content_gating_banner'
import ContentAccessWatcher from 'shared/content_access_watcher';
import WatchSessionLimiter from 'shared/watch_session_limiter';
import KmklabsUtil from 'shared/kmklabs_util';
import AhoyEvent from 'shared/ahoy_event';
import Topic from 'shared/topic';
import { isEmptyObject } from 'shared/vidio_helpers';
import PreviewLoginBanner from 'components/shared/PreviewLoginBanner/PreviewLoginBanner';
import CommentVideoSection from 'shared/components/comment_video_section';
import MuxLoader from 'components/shared/MuxLoader/MuxLoader';

export default class PremiumPlayerInitializer {
  constructor(currentUser){
    this._currentUser = currentUser;
    this.initialPlayerTime = undefined;
  }

  initialize(){
    let contentGatingBanner = this.createContentGatingBanner();
    contentGatingBanner.init();
    if(contentGatingBanner.banner) return;
    if (KmklabsUtil.videoId() && KmklabsUtil.isPremium()){
      this.subscribePreviewEnded();
      this.preparePlayer();
    }
  }

  createContentGatingBanner() {
    return new ContentGatingBanner(this.currentUser);
  }

  subscribePreviewEnded() {
    Topic.subscribe('player/paymentblocker/show', this.showSubscriptionBanner.bind(this));
  }

  showSubscriptionBanner(data) {
    SubscriptionBanner.show(data);
  }

  preparePlayer(){
    let userIsLoggedIn = this.currentUser != null;
    let contentTypeIsVideos = document.querySelector('body').getAttribute('data-controller').includes('videos');

    if (userIsLoggedIn) {
      if(contentTypeIsVideos){
        this.setPlayerStatus('videos');
      }else{
        this.removeContentPreviewStatus();
        this.setPlayerStatus('livestreamings');
      }

      return;
    }

    if(this.playableHasContentPreview()){
      SubscriptionBanner.hide();
      CommentVideoSection.disable();
    } else {
      this.toggleBannerOrCta();
    }

    if (contentTypeIsVideos){
      let defaultData = {source: false, source_dash: false};
      if (window.player != undefined) {
        this.setNewSource(defaultData);
      } else {
        Topic.subscribeOnce('player/ready', this.setNewSource.bind(this, defaultData));
      }
    } else{
      PreviewLoginBanner.show();
    }
  }

  setNewSource(data) {
    let element = this.playerElement();

    if(element == null){
      return;
    }

    let dataSource = data.source

    if(dataSource == false && this.playableHasContentPreview()){
      dataSource = element.getAttribute("data-content-preview-url");
      element.setAttribute("data-preview", "true");
      element.setAttribute("data-drm-enabled", "false");
      element.setAttribute("data-vjs-clip-dash-url", "");
      element.setAttribute("data-vjs-clip-hls-url", "");
    }

    if(data.is_preview){
      element.setAttribute("data-preview", "true");
      element.setAttribute("data-preview-duration", data.preview_duration);
    }

    window.kmklabs.video.source = dataSource;
    window.kmklabs.video.source_dash = data.source_dash;

    if(dataSource == false) {
      element.setAttribute("data-vjs-clip-hls-url", "");
      element.setAttribute("data-vjs-clip-dash-url", "");
      let loader = document.querySelector(".player-loader");
      if (loader) { loader.style.display = 'none'; }
      return;
    }

    if(typeof dataSource == 'string'){
      element.setAttribute("data-vjs-clip-hls-url", dataSource);
    }

    if(typeof data.source_dash == 'string'){
      element.setAttribute("data-vjs-clip-dash-url", data.source_dash);
    }

    PremiumPlayerInitializer.initializePlayer(this.playerId);
  }

  playerElement(){
    if(this._playerElement != null){
      return this._playerElement;
    }

    let element = document.querySelector(`#${this.playerId}`);

    this._playerElement = element;
    return element;
  }

  get playerId(){
    return `player-data-${this.playableId}`;
  }

  playableHasContentPreview(){
    let element = this.playerElement();
    if(element == null) return false;

    return element.getAttribute('data-has-content-preview') == 'true';
  }

  static initializePlayer(playerId){
    const playerInitTime = Date.now();
    window.player = new playback.Player(playerId); // jshint ignore:line
    window.player.initialize();
    MuxLoader.loadAndInit({
      configs: window.mux_configs,
      player_init_time: playerInitTime
    });
  }

  removeContentPreviewStatus(){
    if(!this.playableHasContentPreview()) return;

    let element = this.playerElement();
    element.setAttribute("data-has-content-preview", "false");
  }

  setPlayerStatus(type) {
    $.ajax({
      url: `/interactions_stream.json?video_id=${this.playableId}&type=${type}`,
      dataType: 'json',
      method: 'GET'
    }).done(function(data) {
      this.onInteractionStreamSuccess(type, data);
    }.bind(this)).fail(function(err){
      this.onInteractionStreamFailed(parseInt(err.status), err.responseJSON, type);
    }.bind(this));
  }

  onInteractionStreamSuccess(playableType, data) {
    if (window.player == undefined) {
      Topic.subscribeOnce('player/ready', this.setNewSource.bind(this, data));
    } else {
      this.setNewSource(data);
    }

    this.initComponentInitializer();

    this.toggleSubscriptionBanner(data.source);

    this.initWatchAccess(playableType, data);
  }

  typeChopping(value) {
    if (value === 'videos') return 'video';
    if (value === 'livestreamings') return 'livestreaming';
    return value;
  }

  onInteractionStreamFailed(statusCode, responseJSON, type) {
    var errorCode = 0;
    if(responseJSON){
      errorCode = responseJSON.error_code;
    }
    if(statusCode == 403) {
      if (errorCode == 10030006) {
        var errorMessage = ''
        if( responseJSON && responseJSON.error_message ) {
          errorMessage = responseJSON.error_message;
        }
        this.showWatchLimiterBlocker(type, errorMessage);
      } else {
        this.showWatchLimiterBlocker(type, '');
      }
    }
  }

  showWatchLimiterBlocker(type, errorMessage) {
    WatchSessionLimiter.showBanner(errorMessage);
    WatchSessionLimiter.setBackgroundBlocker();
    AhoyEvent.send('PLAYBACK::BLOCKER', {
      content_type: this.typeChopping(type),
      is_premier: KmklabsUtil.isPremium(),
      content_id: this.playableId,
      blocker_type: 'limitwatch',
    });
  }

  initWatchAccess(playableType, data) {
    if(data.single_watch_session == true){
      WatchSessionLimiter.startHeartbeat(this.playableId);
    }

    if(data.periodic_content_access_check) {
      ContentAccessWatcher.watch(this.playableId, playableType);
    }
  }

  toggleBannerOrCta(){
    let lsStartTime = document.querySelector('.ls-countdown');
    let premierCta = document.querySelector('.player-offer-button');
    if(lsStartTime && premierCta) {
      SubscriptionBanner.hide();
      premierCta.classList.remove('hide');
      AhoyEvent.send('VIDIO::SUBSCRIPTION', {
        action: 'impression',
        single_purchase: premierCta.dataset.singlePurchase == 'true' ? true : false,
        content_id: parseInt(premierCta.dataset.liveId),
        feature: 'upcoming'
      });
    } else {
      SubscriptionBanner.show();
      CommentVideoSection.disable();
    }
  }

  toggleSubscriptionBanner(source){
    if (source == null) {
      return;
    } else if (source == false && !this.playableHasContentPreview()) {
      // on livestreaming, it only changes the title since the banner already shown
      // on VOD, it display the banner
      this.toggleBannerOrCta();
    } else {
      SubscriptionBanner.hide();
    }

    if(source === false) {
      CommentVideoSection.disable();
    }
  }

  initComponentInitializer() {
    new ComponentInitializers();
  }

  get type() {
    if(this._type == undefined) {
      let type = document.querySelector('body').getAttribute('data-controller').includes('videos');
      this.type = type ? 'videos' : 'livestreamings';
    }
    return this.type;
  }

  get currentUser() {
    return isEmptyObject(this._currentUser) ? null : this._currentUser;
  }

  get playableId(){
    if(this._playableId != null){
      return this._playableId;
    }

    this._playableId = KmklabsUtil.videoId();
    return this._playableId;
  }
}
